import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import firebaseConfig from './firebaseConfig';
import { getAnalytics } from "firebase/analytics";

const app = firebase.initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default firebase.firestore();